const SKIP_PREFLIGHT_CHECK = false
const APP_NAME = "LiveDesk"
const TINYMCE_KEY = "v2a36x73f915ypo7tbusjs2p3wsa7d1nh9hrngjna756yrot"
const ALLOWED_ROLES = ["admin", "super_admin", "store operations", "treasury", "accounting", "operations head"]
let GRAPH_URL
let AUTH_URL
let CALL_COLLECT_URL
let ENV

const url = window.location.host.split(":")[0]

// TODO: Update if ace-fulfillment gets sat env
if (url === "livedesk-sat.acehardware.ph") {
  GRAPH_URL = "https://g-sat.smomni.com/graphql"
  AUTH_URL = "https://auth-sat.smomni.com"
  CALL_COLLECT_URL = "https://call-collect-sat.acehardware.ph"
  ENV = "sat"
} else if (url === "livedesk.acehardware.ph") {
  GRAPH_URL = "https://g.smomni.com/graphql"
  AUTH_URL = "https://auth.smomni.com"
  CALL_COLLECT_URL = "https://call-collect.acehardware.ph"
  ENV = "production"
} else {
  GRAPH_URL = "https://g.smomni.com/graphql"
  AUTH_URL = "https://auth.smomni.com"
  CALL_COLLECT_URL = "https://call-collect.acehardware.ph"
  ENV = "production"
}

const EDITOR_KEY = "v2a36x73f915ypo7tbusjs2p3wsa7d1nh9hrngjna756yrot"

console.log("+++++++++++++++++++++++++++++++")
console.log("URL :", url)
console.log("GRAPH :", GRAPH_URL)
console.log("AUTH :", AUTH_URL)
console.log("CALL COLLECT :", CALL_COLLECT_URL)
console.log("+++++++++++++++++++++++++++++++")

export {
  APP_NAME,
  url,
  AUTH_URL,
  GRAPH_URL,
  CALL_COLLECT_URL,
  ALLOWED_ROLES,
  SKIP_PREFLIGHT_CHECK,
  TINYMCE_KEY,
  ENV,
  EDITOR_KEY,
}
